var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"wrap"}},[_c('Main'),_c('Steps'),_c('Banks'),_c('Terms'),_c('CreateStmt'),_c('Consultation'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }